module.exports = __webpack_public_path__ + "static/Technical-Header-1d197d0f0935f6b4a50561813d547345.jpg";